module.exports = __webpack_public_path__ + "img/yyjjfa_04.1586cc66.jpg";